import config from "../../config/config.js";
export async function login(userName, password, portal) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
    body: JSON.stringify({
      UserName: userName,
      Password: password,
      Portal: portal,
    }),
  };
  const response = await fetch(
    config.REG_API_BASE_URL + "/User/login",
    options
  );
  if (!response.ok) {
    if (
      response.status === 404 ||
      response.status === 403 ||
      response.status === 401
    ) {
      return response.json();
    } else {
      throw response;
    }
  } else {
    const data = await response.json();
    return data;
  }
}
